import React, { useState, useRef, useEffect, useContext, act } from 'react';
import {  useLocation } from 'react-router-dom';

import axios from 'axios';
import GlobalContext from './GlobalContext';
import ConsoleLog   from './ConsoleLog';
import logo from './logo.svg';

import {
   Button, ToggleButtonGroup, ToggleButton } from '@mui/material';
import CustomerTree from './CustomerTree';
import Charts from './Charts';
import Goals from './Goals';
import Dashboard from './Dashboard';
import {  CircularProgress } from '@mui/material';


 const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };


 const Home = () =>{
    const [viewDashboard, setViewDashboard] = useState(false);
   const {year, API_URL, roleLevels, goalStatus, displayCurrency, displayPct, currency, setCurrency, setCadRate } = useContext(GlobalContext);
    const [isLeftNavMinimized, setIsLeftNavMinimized] = useState(window.innerWidth < 1200);
    const [activeToken, setActiveToken] = useState(null);
    const [isValidToken, setIsValidToken] = useState(false);
    const [selectedSalesGoalID, setSelectedSalesGoalID] = useState(null);
    const [selectedNode, setSelectedNode] = useState(null); // State to manage the selected node
    const [dashboardRootNode, setDashboardRootNode] = useState(null); // State to manage the selected node

    const [treeData, setTreeData] = useState(null);
    const [salesDetails, setSalesDetails] = useState(null);
    const [salesSummary, setSalesSummary] = useState(null);

    //dashboard ---------------------------------------------------------
    const [brandsCats, setBrandsCats] = useState(null);
    const [distinctBrands, setDistinctBrands] = useState(null);
    const [distinctCategories, setDistinctCategories] = useState(null);
    const [selectedBrand, setSelectedBrand] = useState('ALL BRANDS');
    const [selectedCategory, setSelectedCategory] = useState('ALL CATEGORIES');
    const [filteredCategories, setFilteredCategories] = useState(null);
    const dashboardDataRef = useRef(null);  
    const [dashboardData, setDashboardData] = useState(null);
 
    const [role, setRole] = useState("");
    const [isLoading, setIsLoading] =useState(false);
  const [authError, setAuthError] = useState(null);
    // -----------------------------------------------------------------

    const { search } = useLocation(); // put at top of Home component
    
  function getParamPreservePlus(search, name){
      if (!search) return null;
      const match = search.match(new RegExp(`[?&]${name}=([^&#]*)`));
      if (!match) return null;
      const raw = match[1];
      try {
          // Replace '+' with '%2B' before decoding so '+' is preserved
          return decodeURIComponent(raw.replace(/\+/g, '%2B'));
      } catch (err) {
          return raw;
      }
  }

  // Parses the Server-Timing header value into an array of metric objects
  function parseServerTimingHeader(headerValue) {
    if (!headerValue || typeof headerValue !== 'string') return [];

    const splitOutsideQuotes = (text, delimiter) => {
      const parts = [];
      let current = '';
      let inQuotes = false;
      for (let i = 0; i < text.length; i++) {
        const ch = text[i];
        if (ch === '"') {
          inQuotes = !inQuotes;
          current += ch;
        } else if (ch === delimiter && !inQuotes) {
          parts.push(current.trim());
          current = '';
        } else {
          current += ch;
        }
      }
      if (current.trim()) parts.push(current.trim());
      return parts;
    };

    const metrics = splitOutsideQuotes(headerValue, ',').map(entry => {
      const segments = splitOutsideQuotes(entry, ';');
      const name = (segments[0] || '').trim();
      const params = {};
      for (let i = 1; i < segments.length; i++) {
        const seg = segments[i].trim();
        const eqIdx = seg.indexOf('=');
        if (eqIdx > -1) {
          const key = seg.slice(0, eqIdx).trim();
          let val = seg.slice(eqIdx + 1).trim();
          if (val.startsWith('"') && val.endsWith('"')) {
            val = val.slice(1, -1);
          }
          params[key] = val;
        } else if (seg) {
          // parameter without value
          params[seg] = true;
        }
      }
      const durationMs = params.dur !== undefined ? Number(params.dur) : undefined;
      return {
        metric: name,
        dur: Number.isFinite(durationMs) ? durationMs : undefined,
        desc: params.desc,
        params
      };
    });

    return metrics.filter(m => m.metric);
  }

  function logServerTiming(headerValue, label) {
    const metrics = parseServerTimingHeader(headerValue);
    if (!metrics.length) return;
    try {
      console.groupCollapsed(`[Server-Timing] ${label}`);
      console.table(metrics.map(m => ({ metric: m.metric, dur: m.dur, desc: m.desc })));
      console.groupEnd();
    } catch (_) {
      // Fallback if console.table/group not available
      console.log(`[Server-Timing] ${label}`, metrics);
    }
  }
  
    
    useEffect(() => {

      const handleResize = () => {
        if (window.innerWidth >= 1200) {
          setIsLeftNavMinimized(false); // Automatically expand for larger screens
        } else {
          setIsLeftNavMinimized(true); // Auto-collapse for smaller screens
        }
      };


      const getToken = async (cn, email) => {
        try{
          const response = await axios.get(`${API_URL}/Auth?cn=${encodeURIComponent(cn)}&e=${encodeURIComponent(email)}`);
          return response.data.token;  
        }
        catch(error){
            console.error('Error validating customer number and/or email:', error);
            return false;
        };
  
      }
  

      const cn = getParamPreservePlus(search, 'cn');
      const email = getParamPreservePlus(search, 'e');
      
      if (cn && email) {
            getToken(cn, email).then(resp => {
              let token = resp;
              if (token === "") {
                setAuthError("You lack the permissions necessary to view the Sales Goals Workbook. Please check with My Sonance Support.");
                setActiveToken(null);
                setTreeData(null);
                setSalesDetails(null);
                setSalesSummary(null);
                return;
              }
              setActiveToken(token);
              if(token && token !== false)
                getCustomerTree(token)
                    .then((treeResp) => {
                      setTreeData(treeResp);
                      if(treeResp.rootNode && treeResp.rootNode.children &&  treeResp.rootNode.children.length === 0)
                      {
                         debugger;
                        setViewDashboard(false);
                        setSelectedNode(treeResp.rootNode);
                        setSelectedSalesGoalID(treeResp.rootNode.salesGoalID);
                        setIsLeftNavMinimized(prevState => !prevState);
                      }
                      else{
                        setDashboardRootNode(treeResp.rootNode);
                        if (!dashboardDataRef.current && token) {
                          // Fetch data only if it hasn't been loaded
                          setIsLoading(true);
                          fetchDashboardData(token,treeResp.rootNode);
                        } else {
                          setDashboardData(dashboardDataRef.current);
                          //filterData(selectedBrand, selectedCategory);
                        }
                        debugger;
                        setViewDashboard(true);
                      }
                      
                    })
            }).catch(error => console.error('Error fetching token', error));

        }

        window.addEventListener('resize', handleResize);

        return () => {
          window.removeEventListener('resize', handleResize);
        };
    },[]);

    // Force dashboard view off for Level 1 role
    useEffect(() => {
      if (role === roleLevels.Level1 && viewDashboard) {
        setViewDashboard(false);
      }
    }, [role, roleLevels, viewDashboard]);

    async function fetchDashboardData(token, rootNode) {
      try {
        const bcResponse = await getUniqueBrandsAndCategories(token, rootNode);
        setBrandsCats(bcResponse);
        setDistinctBrands([...new Set(bcResponse.map((item) => item.brand))]);
        
        const uniqueCats = [...new Set(bcResponse.map((item) => item.category))];
        setDistinctCategories(uniqueCats);
        setFilteredCategories(uniqueCats);
  
        const dashboardResponse = await getDashboardSummary(token, selectedBrand, selectedCategory);
        dashboardDataRef.current = dashboardResponse.sort((a, b) => b.ordinal - a.ordinal);
        setDashboardData(dashboardResponse);
        setRole(dashboardResponse[0]?.roleName);
         
         
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false);
      }
    }

    const getDashboardSummary = async (token, brand, category) => {
        try {
            const request = { token, brand: brand ?? selectedBrand, category: category ?? selectedCategory };
            const response = await axios.post(`${API_URL}/salesgoals/dashboardSummary`, request);
            const serverTimingHeader = response?.headers?.['server-timing'];
            if (serverTimingHeader) {
              logServerTiming(serverTimingHeader, 'POST /salesgoals/dashboardSummary');
            }
            return response.data;
          } catch (error) {
            console.error('Error fetching dashboard summary:', error);
            return [];
          }
    };

    

    const handleDashboardBrandChange = async (newBrand) => {
      setIsLoading(true);
      
      setSelectedBrand(newBrand);
      setSelectedCategory('ALL CATEGORIES'); // Reset category when brand changes
  
      // Filter categories based on the selected brand
      const filteredCats = newBrand !== "ALL BRANDS" ? brandsCats
                            .filter((item) => item.brand === newBrand)
                            .map((item) => item.category)
                            : brandsCats
                            .map((item) => item.category);
      
      setFilteredCategories([...new Set(filteredCats)]);
      if(newBrand !== "MULTI")
      {
        setDashboardData(null);
        const dashboardResponse = await getDashboardSummary(activeToken, newBrand, 'ALL CATEGORIES');
        dashboardDataRef.current = dashboardResponse.sort((a, b) => b.ordinal - a.ordinal);
        setDashboardData(dashboardResponse);
        // Update filtered data based on the new brand
      }
      
       
      setIsLoading(false);
      
    };
  
    const handleDashboardCategoryChange = async (newCategory) => {
      setIsLoading(true);
      setDashboardData(null);
  
      let brandToUse = selectedBrand;
  
      // If user selects a specific category first (not ALL), infer the brand
      if (newCategory !== 'ALL CATEGORIES') {
        if (selectedBrand === 'ALL BRANDS' || selectedBrand === 'MULTI' || !selectedBrand) {
          const matchingBrands = (brandsCats || [])
            .filter((item) => item.category === newCategory)
            .map((item) => item.brand);
          const uniqueBrands = [...new Set(matchingBrands)];
  
          if (uniqueBrands.length === 1) {
            brandToUse = uniqueBrands[0];
            setSelectedBrand(brandToUse);
  
            // Update filtered categories to those available for the inferred brand
            const filteredCats = (brandsCats || [])
              .filter((item) => item.brand === brandToUse)
              .map((item) => item.category);
            setFilteredCategories([...new Set(filteredCats)]);
          }
          // If multiple brands share the category, keep current brand selection
        }
      }
  
      setSelectedCategory(newCategory);
      const dashboardResponse = await getDashboardSummary(activeToken, brandToUse, newCategory);
      dashboardDataRef.current = dashboardResponse.sort((a, b) => b.ordinal - a.ordinal);
      setDashboardData(dashboardResponse);
      setIsLoading(false);
    };

    const getUniqueBrandsAndCategories = async (token, rootNode) => {
      try {
          const request = { token: token, treeNode: rootNode?.name };
          const response = await axios.post(`${API_URL}/salesgoals/brandscategories`, request);
          return response.data;
      } catch (error) {
          console.error('Error fetching brands and categories:', error);
      return [];
      }
  };

 

    async function getSalesGoalsSummary() {
       const response = await axios.get(`${API_URL}/salesgoals/summary?token=${activeToken}&treeNode=${selectedNode.name}&treeNodeName=${selectedNode.description}&salesGoal=${selectedSalesGoalID}`)
       return response.data;
      
    }

    async function getCustomerTree(token) {
      const response = await axios.get(`${API_URL}/salesgoals/tree?token=${token}`);
      return response.data;
      
  }

    useEffect(() => {
        if(selectedNode){
          setViewDashboard(false);
          setIsLoading(true);
          
          getSalesGoalsSummary()
          .then((response) => {
              setSalesDetails(response.details);
              setSalesSummary(response.summary);
              setCadRate(response.rateCAD);
              
              setRole(response.details[0]?.roleName);
          })
          .catch(error => {
              console.error('Error fetching data:', error);
          })
          .finally(stuff =>
            setIsLoading(false)
          );
        }
           
    }, [selectedNode,selectedSalesGoalID]);


    const handleNodeClick = ( salesGoalID, node) => {
      
      setSalesDetails(null);
      setSalesSummary(null);
        setSelectedNode(node);
        setSelectedSalesGoalID(salesGoalID);
        setViewDashboard(false);
        

    };


    function findNodeByName(node, nodeDesc) {
      if (node.description === nodeDesc) {
        return node;
      }
    
      for (let child of node.children) {
        const result = findNodeByName(child, nodeDesc);
        if (result) {
          return result;
        }
      }
    
      return null; // Return null if the node is not found
    }

  function findFirstNodeWithSalesGoal(node) {
    if (!node) return null;
    if (node.salesGoalID) return node;
    if (node.children && node.children.length > 0) {
      for (let child of node.children) {
        const found = findFirstNodeWithSalesGoal(child);
        if (found) return found;
      }
    }
    return null;
  }

    const handleDashboardNodeClick = (nodeDesc) =>{
      const fullNode = findNodeByName(treeData.rootNode, nodeDesc);
      if (fullNode) {
        setSelectedNode(fullNode);
        setSelectedSalesGoalID(fullNode.salesGoalID);
        
      } else {
        console.log("Node not found!");
      }


    }

    // If Level 1 and no selectedNode, select the first available node so details load
    useEffect(() => {
      if (role === roleLevels.Level1 && !selectedNode && treeData && treeData.rootNode) {
        const first = findFirstNodeWithSalesGoal(treeData.rootNode) || treeData.rootNode;
        if (first) {
          setSelectedNode(first);
          setSelectedSalesGoalID(first.salesGoalID || "");
          setViewDashboard(false);
        }
      }
    }, [role, roleLevels, selectedNode, treeData]);

    // Toggle minimize/expand manually
    const toggleMinimize = () => {
      setIsLeftNavMinimized(prevState => !prevState);
    };

      const handleGoalsRefresh = () =>{
        setIsLoading(true);
        getSalesGoalsSummary()
            .then((response) => {
                setSalesDetails(response.details);
                setSalesSummary(response.summary);
            })
            .catch(error => {
              console.error('Error fetching data:', error);
          })
          .finally(stuff =>
            setIsLoading(false)
          );
    }

  // Silent refresh: updates data without toggling loading state or layout
  const handleGoalsRefreshSilent = () =>{
    getSalesGoalsSummary()
        .then((response) => {
            setSalesDetails(response.details);
            setSalesSummary(response.summary);
        })
        .catch(error => {
          console.error('Error fetching data (silent):', error);
      });
  }

    
    const handleTreeRefresh = (node) =>{
        getCustomerTree(activeToken).then(response =>
        {
          setTreeData(response);
          setSelectedNode(node)
        })
        .catch(err => console.log(err));
    }

    const handleCurrencyChange = (_e, next) => {
      if (!next) return; // ignore deselect
      setCurrency(next);
    };
    
    return (
        <>
        {/* <div className='topBanner'>
            <img src="https://images.salsify.com/image/upload/s--UfN66dX_--/lcjysm1wbbdbjjlez449"  />
        </div> */}
        <div className='pageContainer'>
            <div className='headerContainer'>
            {console.log("viewDashboard", viewDashboard)}
            {console.log("role", role)}
            {console.log("roleLevels.Level1", roleLevels.Level1)}
              { !viewDashboard && !authError && role !== roleLevels.Level1 && (
                   <Button onClick={() => setViewDashboard(!viewDashboard)}> Back to Summary Dashboard</Button>
                )}
                {/* <h1>Sales Goals Workbook</h1> */}
               {/*<div className="currencyToggle">
                 <ToggleButtonGroup
                   size="small"
                   color="primary"
                   exclusive
                   value={currency}
                   onChange={handleCurrencyChange}
                 >
                   <ToggleButton value="USD">USD</ToggleButton>
                   <ToggleButton value="CAD">CAD</ToggleButton>
                 </ToggleButtonGroup>
               </div>*/}
                 
             </div>
             
            <div className="interiorContainer">
              {
                treeData && (      
                  <div
                  className="leftContainer"
                  style={{
                    width: isLeftNavMinimized ? '50px' : '350px', // Adjust width based on state
                    transition: 'width 0.6s ease', // Smooth transition
                  }}
                >
                  <div className="burger-icon-container">
                    <button onClick={toggleMinimize} className="burger-icon">&#9776;</button>
                  </div>
                  <div className="content" style={{ display: isLeftNavMinimized ? 'none' : 'block' }}>
                    <React.Fragment>
                      <CustomerTreeLegend treeData={treeData.rootNode} />
                      <div className="customerTree">
                        <CustomerTree nodes={treeData} onNodeClick={handleNodeClick} selectedNode={selectedNode} />
                       </div>
                      
                    </React.Fragment>
                </div>
             </div>
              )
            }
            <div
                className="rightContainer"
                style={{
                  width: isLeftNavMinimized ? 'calc(100% - 50px)' : 'calc(100% - 350px)', // Adjust right container width dynamically
                  transition: 'width 0.6s ease', // Smooth transition
                }}
              >
                  {authError && (
                    <div style={{
                      background: '#fdecea',
                      color: '#611a15',
                      border: '1px solid #f5c6cb',
                      padding: '12px 16px',
                      borderRadius: '6px',
                      margin: '12px 0'
                    }}>
                      {authError}
                    </div>
                  )}
                  {viewDashboard && (dashboardData || isLoading) && !authError && (
                     <div className='summaryTable'>
                        <Dashboard role={role} 
                         dashboardData={dashboardData}
                         distinctBrands={distinctBrands}
                         filteredCategories={filteredCategories}
                         selectedBrand={selectedBrand}
                         selectedCategory={selectedCategory}
                         handleBrandChange={handleDashboardBrandChange}
                         handleCategoryChange={handleDashboardCategoryChange}
                         isLoading={isLoading}
                         
                         selectChannelNode={handleDashboardNodeClick} />
                      </div>
                  )}

                  {
                    !viewDashboard && selectedNode && !authError && (
                      <React.Fragment>
                        {isLoading && !salesDetails && (
                          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress size="30px" />
                          </div>
                        )}
                        {!isLoading && salesDetails && (
                          <React.Fragment>
                            <div className='charts'>
                              <ConsoleLog status={salesDetails[0].status} />
                              <Charts summary={salesSummary} salesGoalID={selectedSalesGoalID} status={salesDetails[0].status} />
                            </div>
                            <div className='summaryTable'>
                              <Goals
                                token={activeToken}
                                goalsData={salesDetails}
                                treeNode={selectedNode}
                                salesGoalID={selectedSalesGoalID}
                                isLoading={isLoading}
                                refresh={handleGoalsRefresh}
                                refreshSilent={handleGoalsRefreshSilent}
                                refreshTree={handleTreeRefresh}
                              />
                            </div>
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    )
                  }

                  {
                    !activeToken && !authError && (
                      <p>Loading...</p>
                    )
                  }
              </div>
            </div>
        </div>
        
        </>
        

 
       
     
    );
}


const CustomerTreeLegend = ({treeData}) =>{
   if(treeData && treeData.children.length > 0  )
      return (


          <div className="legend">
              <div className="legendItem lockLevel1">Level 1</div>
              <div className="legendItem lockLevel2">Level 2</div>
              <div className="legendItem lockLevel3">Level 3</div>
              <div className="legendItem lockFinal">Final</div>
              <div className="clear" />
        </div>
      );
      else
      return (<></>);
}
export default Home;